import { render, staticRenderFns } from "./WpOrderItem.vue?vue&type=template&id=06318de7&scoped=true"
import script from "./WpOrderItem.vue?vue&type=script&lang=js"
export * from "./WpOrderItem.vue?vue&type=script&lang=js"
import style0 from "./WpOrderItem.vue?vue&type=style&index=0&id=06318de7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06318de7",
  null
  
)

export default component.exports